import { Button, Flex } from "antd";
import { DownloadIcon, FilterIcon } from "../../assets";
import ButtonSwitch from "../../components/ButtonSwitch";
import { IconPrimary, Popup } from "../../components";
import FilterForm from "../../forms/FilterForm";
import { usePopup } from "../../hooks/usePopup";
import AppliedFilter from "../../forms/AppliedFilter";
import { useEffect, useState } from "react";
import VoucherAtcTable from "./VoucherAtcTable";
import VoucherPublicTable from "./VoucherPublicTable";
import { getAtc } from "../../redux/apiActions/atcActions";
import { getExams } from "../../redux/apiActions/examActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import Select from "../../components/Select";
import {
  getAtcState,
  getExamState,
  getVoucherState,
} from "../../redux/store/getState";
import downloadDataIExcelSheet from "../../utils/downloadDataIExcelSheet";
import useUser from "../../hooks/useUser";

const buttons = ["ATC Admin", "Public Users"];

export default function VoucherManagement() {
  const [activeButton, setActiveBtn] = useState<string | null>(null);
  const popup = usePopup();
  const dispatch = useAppDispatch();

  const { atc, loading } = useAppSelector(getAtcState);
  const { exams, loading: examLoading } = useAppSelector(getExamState);
  const { user } = useUser();

  const isHaveEditPermission = user?.permissions?.includes("voucher.edit");

  const {
    vouchersAtc,
    vouchersPublic,
    loading: voucherLoading,
  } = useAppSelector(getVoucherState);

  useEffect(() => {
    dispatch(getAtc());
    dispatch(getExams());
  }, [dispatch]);

  return (
    <>
      <Flex gap="large" wrap="wrap">
        <ButtonSwitch
          buttons={buttons}
          onSwitch={(activeButton: string) => setActiveBtn(activeButton)}
        />
        <Popup
          ref={popup.popupRef}
          openTrigger={
            <Button icon={<FilterIcon style={{ marginTop: 2 }} />}>
              Filter
            </Button>
          }
        >
          <FilterForm
            popup={popup}
            extraFormItem={
              <>
                <div
                  className="full-width-divider"
                  style={{ marginBottom: 20 }}
                />
                {activeButton === "Public Users" ? (
                  <Select
                    options={exams}
                    loading={examLoading.getExam}
                    placeholder={"Select Exam"}
                    formItemProps={{
                      name: "atc_id",
                      label: "Select Exam",
                      rules: [{ required: true, message: "ATC is required" }],
                    }}
                  />
                ) : (
                  <Select
                    options={atc}
                    loading={loading.getAtc}
                    formItemProps={{
                      label: "ATC",
                      name: "atc_id",
                      rules: [{ required: true, message: "ATC is required" }],
                    }}
                    placeholder="Select ATC"
                  />
                )}
              </>
            }
          />
        </Popup>
        <AppliedFilter />
        {!voucherLoading.getRequest ? (
          <Flex justify="end" flex={1}>
            <IconPrimary
              onClick={() =>
                downloadDataIExcelSheet(
                  activeButton === "Public Users"
                    ? vouchersPublic
                    : vouchersAtc,
                  "voucher"
                )
              }
              disabled={!isHaveEditPermission}
            >
              <DownloadIcon />
            </IconPrimary>
          </Flex>
        ) : null}
      </Flex>

      {activeButton === "Public Users" ? (
        <VoucherPublicTable />
      ) : (
        <VoucherAtcTable />
      )}
    </>
  );
}
